import { useTranslation } from "react-i18next";
import { Modal } from "~/components/modal/modal";
import { IProduct } from "~/integrations/firebase/collections";
import { useOnixGeneration } from "~/hooks/use-onix-generation";
import { OnixGenerationModal } from "~/pages/project-details/table/onix-generation-modal";

interface OnixExportDialogsProps {
  products: IProduct[];
  showWarning: boolean;
  onShowWarningChange: (show: boolean) => void;
}

export const OnixExportDialogs = ({
  products,
  showWarning,
  onShowWarningChange,
}: OnixExportDialogsProps) => {
  const { t } = useTranslation(["projectDetails"]);
  const {
    showOnixExportModal,
    setShowOnixExportModal,
    onixUrl,
    handleOnixExportButtonClick,
    generatingStatus,
    setGeneratingStatus,
  } = useOnixGeneration();

  const handleWarningConfirm = async () => {
    onShowWarningChange(false);
    await handleOnixExportButtonClick(products);
  };

  return (
    <>
      <Modal
        id="onix-warning"
        open={showWarning}
        onOpenChange={onShowWarningChange}
        title={t("projectDetails:modals.exportOnix.warning.title")}
        description={t("projectDetails:modals.exportOnix.warning.description")}
        confirmLabel={t("projectDetails:modals.exportOnix.warning.confirm")}
        cancelLabel={t("projectDetails:modals.exportOnix.warning.cancel")}
        variant="warning"
        onConfirm={handleWarningConfirm}
      />

      <OnixGenerationModal
        onixUrl={onixUrl}
        showOnixExportModal={showOnixExportModal}
        setShowOnixExportModal={setShowOnixExportModal}
        generatingStatus={generatingStatus}
        setGeneratingStatus={setGeneratingStatus}
      />
    </>
  );
};
